var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * @Author: yejianfei
 * @Date: 2023-04-03 22:34:45
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-17 16:21:28
 * @Description:
 * @Developer:
 */
import React from 'react';
import AdminPage from '../../components/antd/AdminPage';
import { Button, Card, Col, Form, Input, Row, Space, Radio } from 'antd';
import { UserAddOutlined } from '@ant-design/icons';
import APITable from '../../components/antd/APITable';
import WithRouter, { RouterContext } from '../../components/WithRouter';
import APITreeSelect from '../../components/antd/APITreeSelect';
import { HospitalGroupOptions, HospitalGroupFilter, UserTypeOptions, UserTypeFilter } from '../../options';
let AdminUserListPage = class AdminUserListPage extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {};
        this.errMessage = {
            10101: '用户已存在'
        };
    }
    render() {
        return (React.createElement(AdminPage, null,
            React.createElement(Card, { style: { height: '100%' }, bodyStyle: { padding: 12, height: '100%' } },
                React.createElement(APITable, { bordered: true, tableLayout: 'fixed', loader: `/admin/users/list/:page`, initialParams: {
                        page: 1,
                        size: 25,
                        group: 'cn.com.one2three.hospital.*',
                        filters: true
                    }, size: 'small', rowKey: 'id', 
                    // scroll={{y: 100}}
                    pagination: { showSizeChanger: false }, columns: [{
                            title: '登录手机',
                            width: 200,
                            align: 'center',
                            dataIndex: 'phone'
                        }, {
                            title: '真实姓名',
                            width: 200,
                            align: 'center',
                            dataIndex: 'name'
                        }, {
                            title: '电子邮箱',
                            width: 200,
                            align: 'center',
                            dataIndex: 'email'
                        }, {
                            title: '医护角色',
                            width: 200,
                            align: 'center',
                            dataIndex: 'group',
                            render: (value) => HospitalGroupFilter[value]
                        }, {
                            title: '账户类型',
                            width: 200,
                            align: 'center',
                            dataIndex: 'type',
                            render: (value) => UserTypeFilter[value]
                        }, {
                            title: '操作',
                            dataIndex: 'operation',
                            align: 'center',
                            width: 200,
                            render: ((text, record, index, instance) => {
                                return (React.createElement(Space, null,
                                    React.createElement(Button, { type: "link", onClick: () => instance.modal(record.id) }, "\u7F16\u8F91"),
                                    React.createElement(Button, { danger: true, type: "link", onClick: () => instance.delete(record.id) }, "\u5220\u9664")));
                            })
                        }], search: {
                        children: (table) => {
                            return (React.createElement(Row, null,
                                React.createElement(Col, { span: 8 },
                                    React.createElement(Form.Item, { name: ['keywords'] },
                                        React.createElement(Input.Search, { placeholder: '\u8F93\u5165\u8D26\u53F7\u540D\u79F0\u68C0\u7D22', allowClear: true, enterButton: true, onSearch: () => table.search() }))),
                                React.createElement(Col, { flex: 1 },
                                    React.createElement(Row, { justify: 'end' },
                                        React.createElement(Space, null,
                                            React.createElement(Form.Item, null,
                                                React.createElement(Button, { onClick: () => table.modal(), icon: React.createElement(UserAddOutlined, null) })))))));
                        }
                    }, form: {
                        title: '账号信息',
                        action: '/admin/users',
                        loader: '/admin/users/:id',
                        name: 'user-form',
                        initialValues: {
                            mode: 0,
                            groups: ['cn.com.one2three.hospital.doctor', 'cn.com.one2three.hospital.nurse']
                        },
                        onSucceededMessage: (method, res, values) => {
                            this.context.message({ type: 'success', content: '操作成功' });
                        },
                        onFailedMessage: (method, error, values) => {
                            this.context.message({ type: 'error', content: this.errMessage[error] || '未知错误，请联系管理员' });
                        },
                        onLoaded: (values) => __awaiter(this, void 0, void 0, function* () { return (Object.assign(Object.assign({}, values), { password: Date.now() })); }),
                        children: (values) => (React.createElement(React.Fragment, null,
                            React.createElement(Form.Item, { label: '\u767B\u5F55\u624B\u673A', labelCol: { span: 5 }, name: ['username'], rules: [
                                    { required: true, message: '请输入登录手机' },
                                    { message: '请输入正确的手机', pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/ }
                                ] },
                                React.createElement(Input, { disabled: !!values.id, placeholder: '\u8F93\u5165\u767B\u5F55\u624B\u673A' })),
                            React.createElement(Form.Item, { label: '\u767B\u5F55\u5BC6\u7801', labelCol: { span: 5 }, name: ['password'], rules: [{ required: true, message: '请输入登录密码' }] },
                                React.createElement(Input.Password, { disabled: !!values.id, placeholder: '\u8F93\u5165\u767B\u5F55\u5BC6\u7801' })),
                            React.createElement(Form.Item, { label: '\u771F\u5B9E\u59D3\u540D', labelCol: { span: 5 }, name: ['name'], rules: [
                                    { required: true, message: '请输入真实姓名' },
                                    { message: '只能输入中文字符', pattern: /^[\u4e00-\u9fa5]+$/ }
                                ] },
                                React.createElement(Input, { placeholder: '\u8F93\u5165\u771F\u5B9E\u59D3\u540D\uFF08\u53EF\u9009\uFF09' })),
                            React.createElement(Form.Item, { label: '\u7535\u5B50\u90AE\u7BB1', labelCol: { span: 5 }, name: ['email'] },
                                React.createElement(Input, { placeholder: '\u8F93\u5165\u8054\u7CFB\u90AE\u7BB1\uFF08\u53EF\u9009\uFF09' })),
                            React.createElement(Form.Item, { label: '\u533B\u62A4\u89D2\u8272', labelCol: { span: 5 }, name: ['group'], rules: [{ required: true, message: '请选择' }] },
                                React.createElement(Radio.Group, { options: HospitalGroupOptions.map(item => ({ label: item.name, value: item.id })) })),
                            React.createElement(Form.Item, { label: '\u8D26\u6237\u7C7B\u578B', labelCol: { span: 5 }, name: ['type'], rules: [{ required: true, message: '请选择' }] },
                                React.createElement(Radio.Group, { options: UserTypeOptions.map(item => ({ label: item.name, value: item.id })) })),
                            React.createElement(Form.Item, { label: '\u533B\u9662\u79D1\u5BA4', labelCol: { span: 5 }, name: ['organization_paths'], rules: [
                                    { required: true, validator: (_, value) => {
                                            if (!value || value.length === 0) {
                                                return Promise.reject(new Error('请正确选择医院/科室'));
                                            }
                                            const array = value.filter((item) => !item || item.split('/').length !== 2);
                                            if (array && array.length !== 0) {
                                                return Promise.reject(new Error('请正确选择医院/科室'));
                                            }
                                            return Promise.resolve();
                                        } }
                                ] },
                                React.createElement(APITreeSelect, { loader: {
                                        root: '/admin/organizations/tree/:path/children?type=hospital',
                                        children: '/admin/organizations/tree/:path/children',
                                    }, params: {
                                        path: 'root'
                                    }, multiple: true, treeCheckable: true, showSearch: false, leafSelectableOnly: true, leafCheckableOnly: true, depth: 2 }))))
                    } }))));
    }
};
AdminUserListPage.contextType = RouterContext;
AdminUserListPage = __decorate([
    WithRouter()
], AdminUserListPage);
export default AdminUserListPage;
